<span>
  <basin-numeric-range
    [outputFormat]="props.outputFormat"
    [placeholder]="props.placeholder"
    [required]="props.required"
    [validRanges]="props.validRanges"
    [validationMessages]="props.validationMessages"
    (onFocus)="props.onFocus && props.onFocus(field, $event)"
    (onBlur)="props.onBlur && props.onBlur(field, $event)"
    (onInput)="props.onInput && props.onInput(field, $event)"
    (onClear)="props.onClear && props.onClear(field, $event)"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [readonly]="props.readonly"
  ></basin-numeric-range>
</span>
